// extracted by mini-css-extract-plugin
module.exports = {"container":"TagList_container__355PE"};